import React, { memo } from 'react';
import { Grid, Link } from '@material-ui/core';
import { TemplateUtilityLink } from '../../store/interfaces/template';
import { IELink } from './IELink';

interface UtilityLinksProps {
  link: TemplateUtilityLink;
  classes: Record<string, string>;
  component?: React.ElementType;
}

const StateLessUtilityLink = (props: UtilityLinksProps): JSX.Element => {
  const { link, classes, component = 'div' } = props;
  if (link.label) {
    return (
      <Grid item className={classes.utilityLink} component={component}>
        <Link href={link.url ? link.url : '#'} target={'_blank'} variant="body2">
          <IELink>{link.label}</IELink>
        </Link>
      </Grid>
    );
  }
  return <></>;
};

export const UtilityLink = memo(StateLessUtilityLink);
